import * as React from 'react';

import { cn } from '@rematter/ui-web';

import { transportationModule } from '~/modules/transportation';
import { ModuleLayout } from '~/shared/layouts/ModuleLayout';

type TransportationRootLayoutProps = {
  children: React.ReactNode;
  className?: string;
};

export const TransportationRootLayout = ({
  children,
  className,
}: TransportationRootLayoutProps) => (
  <ModuleLayout
    module={transportationModule}
    noContentPadding={true}
    className={cn('@TransportationRootLayout', className)}
  >
    {children}
  </ModuleLayout>
);
